import React from "react";
import OrderReturnPage from "./components/OrderReturnPage";
import { returnOrderStatus } from "../../../constants/orderStatus";

const LostInTransit = () => {
  return (
    <>
      <OrderReturnPage
        type={returnOrderStatus.LOST_IN_TRANSIT}
        hideBulkActions={true}
      />
    </>
  );
};

export default LostInTransit;
